import { StatsCommon } from '#common/stats';
export class FilespaceStats extends StatsCommon {
    fs;
    objectStore;
    permissions;
    node;
    epoch;
    session;
    metaStore;
    network;
    keyRangeLocking;
}
